import React,{ Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import { Modal, ModalHeader,ModalBody } from 'reactstrap';
import Timeline from './Timeline';

class Logs extends Component{
    render = () => {
        const { toggleModal, modalStore: { logs: { modal, data: { logs = [] } } } } = this.props;
        return (
            <span>
                <Modal isOpen={modal} toggle={() => toggleModal("jobs","logs")}>
                    <ModalHeader style={{backgroundColor:"#f0f0f0"}} toggle={() => toggleModal("jobs","logs")}>Logs</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f0f0f0"}}>
                        <Timeline logs={logs}/>
                    </ModalBody>
                </Modal>
            </span>
        )
    }
}

const mapStateToProps = (state) => ({
    modalStore: state.modalStore.jobs,
});

const { modals } = Actions;

export default connect(mapStateToProps,{ ...modals })(Logs);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/Logs.js